export const daysOfWeek = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const daysOfWeekMap = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

export const monthDates = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

export function generateCron({
  frequency,
  time,
  weekDays,
  monthDays,
  dayOfMonth,
  monthOfYear,
}) {
  if (!time) return "* * * * * *";

  const minute = time.getUTCMinutes();
  const hour = time.getUTCHours();

  if (frequency === "DAILY") {
    return `0 ${minute} ${hour} * * *`;
  }

  if (frequency === "WEEKLY") {
    const days =
      weekDays.length > 0
        ? weekDays.map((d) => daysOfWeekMap[d.toUpperCase()]).join(",")
        : "*";
    return `0 ${minute} ${hour} * * ${days}`;
  }

  if (frequency === "MONTHLY") {
    const days =
      monthDays && monthDays.length > 0 ? monthDays.join(",") : "1";
    return `0 ${minute} ${hour} ${days} * *`;
  }

  if (frequency === "QUARTERLY") {
    return `0 ${minute} ${hour} ${dayOfMonth} 1,4,7,10 ?`;
  }

  if (frequency === "YEARLY") {
    return `0 ${minute} ${hour} ${dayOfMonth} ${monthOfYear} ?`;
  }

  return "* * * * * *";
}
